import * as React from 'react';
import { Icon } from '../../Icon';
import { IIcon } from '../../../interfaces/IIcon';

export function LevelIcon({ width, height, viewBox, style, className }: IIcon) {
    const newViewProps = '0 0 16 16' ?? viewBox;
    return (
        <Icon
            width={width}
            height={height}
            viewBox={newViewProps}
            style={style}
            className={className}
        >
            <path d="M9.01462 0.235964C8.37556 -0.0786543 7.62444 -0.078655 6.98538 0.235964L0.620284 3.3698C-0.206759 3.77698 -0.206764 4.95028 0.620284 5.35748L6.98538 8.49127C7.62444 8.80596 8.37556 8.80596 9.01462 8.49135L15.3797 5.35748C16.2068 4.95029 16.2068 3.77699 15.3797 3.3698L9.01462 0.235964ZM0.6568 6.98815C0.75808 6.93825 0.876771 6.93825 0.978044 6.98815L6.98538 9.94582C7.62444 10.2604 8.37556 10.2604 9.01462 9.94582L15.022 6.98815C15.1232 6.93825 15.2419 6.93825 15.3432 6.98815L15.3797 7.00611C16.2068 7.41331 16.2068 8.58662 15.3797 8.99382L9.01462 12.1276C8.37556 12.4423 7.62444 12.4423 6.98538 12.1276L0.620284 8.99382C-0.206764 8.58662 -0.206759 7.41331 0.620284 7.00611L0.6568 6.98815ZM0.978044 10.6246C0.876771 10.5747 0.75808 10.5747 0.6568 10.6246L0.620284 10.6425C-0.206759 11.0497 -0.206764 12.2231 0.620284 12.6303L6.98538 15.7641C7.62444 16.0787 8.37556 16.0787 9.01462 15.7641L15.3797 12.6303C16.2068 12.2231 16.2068 11.0497 15.3797 10.6425L15.3432 10.6246C15.2419 10.5747 15.1232 10.5747 15.022 10.6246L9.01462 13.5823C8.37556 13.8969 7.62444 13.8969 6.98538 13.5823L0.978044 10.6246Z" />
        </Icon>
    );
}
